import { useNavigate, useParams } from 'react-router-dom';

import { UploadContentLayout } from '@/layout';

import { CreateEditCoverPhotos } from '../CoverPhotos/CreateEditCoverPhoto';

export const UploadContentCreateCoverPhoto = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  return (
    <UploadContentLayout goBack={() => navigate(`/events/${eventId}/upload-content/cover-photos`)}>
      <CreateEditCoverPhotos isUploadPage />
    </UploadContentLayout>
  );
};
